<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData"
      @openDetailDialog="openDetailDialog"
      ref="tableMain"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openDetailDialog="openDetailDialog"
      />
    </Main>

    <el-dialog
      v-if="bankDetailDialogParams.visible"
      show-close
      :visible.sync="bankDetailDialogParams.visible"
      width="800px"
      :title="bankDetailDialogParams.title"
      :close-on-click-modal="false"
      :before-close="() => (bankDetailDialogParams.visible = false)"
      v-el-dialog-drag
    >
      <DetailForm
        ref="detailForm"
        :disabled="bankDetailDialogParams.disabled"
        :custBankCode="bankDetailDialogParams.code"
        :type="bankDetailDialogParams.type"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!bankDetailDialogParams.disabled"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import DetailForm from '../detail'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main, Header, DetailForm },
  props: {
    custCode: { type: String, default: () => '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      bankDetailDialogParams: {
        visible: false,
        title: '',
        type: '',
        code: '',
        disabled: false,
      },
    }
  },
  watch: {
    custCode: {
      handler(custCode) {
        if (custCode !== '') {
          this.getData()
        }
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      if (this.custCode) {
        this.loading = true
        this.$api
          .masterCustomerBankListApi({ custCode: this.custCode })
          .then((res) => {
            this.loading = false
            this.tableData = res.body.data
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    openDetailDialog({ type, form = {} }) {
      if (!this.custCode) {
        this.$message.warning('请保存客户信息')
        return
      }
      const types = {
        add: this.$l('INDEX.form_label_add_bank_account_information') ||'添加银行账号信息',
        edit: this.$l('INDEX.form_label_edit_bank_account_information') ||'编辑银行账号信息',
        detail: this.$l('INDEX.form_label_bank_account_details') || '银行账号详情',
      }
      this.bankDetailDialogParams = {
        visible: true,
        title: types[type],
        code: form.custBankCode,
        type: type,
        disabled: type === 'detail',
      }
    },
    save() {
      this.$refs.detailForm.getForm().then((res) => {
        if (!res) return

        this.loadingOpen()
        this.$api
          .masterCustomerBankSaveApi({ ...res, custCode: this.custCode })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || res.msg,
              type: 'success',
            })
            this.getData()
            this.close()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    close() {
      this.bankDetailDialogParams.visible = false
    },
    getTableData() {
      return this.tableData
    },
  },
}
</script>
